import React, { useEffect, useState, useCallback } from "react";
import DataGrid, { Column, Editing, RequiredRule } from "devextreme-react/data-grid";
import {
	getDeleteReasons,
	addDeleteReason,
	updateDeleteReason,
	deleteDeleteReason,
} from "../../api/apiServiceFetch";
import "./DeletionMessages.scss";

const CATEGORIES = [
	{ value: "profile", label: "Профиль" },
	{ value: "photo", label: "Фото" },
	{ value: "selfie", label: "Селфи" },
];

const DeletionMessages = () => {
	const [reasons, setReasons] = useState([]);

	const reload = useCallback(async () => {
		try {
			setReasons((await getDeleteReasons()) ?? []);
		} catch (e) {
			console.error("Load delete reasons error:", e);
		}
	}, []);

	useEffect(() => {
		reload();
	}, [reload]);

	const handleRowInserting = async (e) => {
		e.cancel = true;
		try {
			await addDeleteReason({
				category: e.data.category,
				textEn: e.data.textEn ?? "",
				textRu: e.data.textRu ?? "",
				textHy: e.data.textHy ?? "",
				isActive: e.data.isActive ?? true,
			});
			await reload();
		} catch (err) {
			console.error("Insert delete reason error:", err);
			alert("Не удалось сохранить сообщение");
		}
	};

	const handleRowUpdating = async (e) => {
		e.cancel = true;
		const updated = { ...e.oldData, ...e.newData };
		try {
			await updateDeleteReason(updated.id, {
				category: updated.category,
				textEn: updated.textEn ?? "",
				textRu: updated.textRu ?? "",
				textHy: updated.textHy ?? "",
				isActive: updated.isActive ?? true,
			});
			await reload();
		} catch (err) {
			console.error("Update delete reason error:", err);
			alert("Не удалось сохранить сообщение");
		}
	};

	const handleRowRemoving = async (e) => {
		e.cancel = true;
		try {
			await deleteDeleteReason(e.data.id);
			await reload();
		} catch (err) {
			console.error("Delete delete reason error:", err);
			alert("Не удалось удалить сообщение");
		}
	};

	// New rows must start visibly active — otherwise the unchecked checkbox
	// contradicts the isActive=true default the insert would send.
	const handleInitNewRow = (e) => {
		e.data.isActive = true;
	};

	return (
		<div className="deletion-messages">
			<h2>Сообщения удаления</h2>
			<DataGrid
				dataSource={reasons}
				keyExpr="id"
				showBorders={true}
				wordWrapEnabled={true}
				onRowInserting={handleRowInserting}
				onRowUpdating={handleRowUpdating}
				onRowRemoving={handleRowRemoving}
				onInitNewRow={handleInitNewRow}
			>
				<Editing mode="row" allowAdding={true} allowUpdating={true} allowDeleting={true} useIcons={true} />
				<Column dataField="id" caption="ID" allowEditing={false} width={60} />
				<Column
					dataField="category"
					caption="Категория"
					width={130}
					lookup={{ dataSource: CATEGORIES, valueExpr: "value", displayExpr: "label" }}
				>
					<RequiredRule />
				</Column>
				<Column dataField="textRu" caption="Текст (RU)">
					<RequiredRule />
				</Column>
				<Column dataField="textHy" caption="Текст (HY)">
					<RequiredRule />
				</Column>
				<Column dataField="textEn" caption="Текст (EN)">
					<RequiredRule />
				</Column>
				<Column dataField="isActive" caption="Активно" dataType="boolean" width={100} />
			</DataGrid>
		</div>
	);
};

export default DeletionMessages;
